import { jsx as j } from "react/jsx-runtime";
import { tv as n } from "../tailwind-variants.config.js";
const m = n({
  base: "jm-font-paragraph-1 jm-p-2 jm-text-center jm-rounded-lg",
  variants: {
    color: {
      blue: "jm-bg-jutro-new-blue-100 jm-text-jutro-new-blue-900",
      brandBlue: "jm-bg-jutro-new-blue-800 jm-text-jutro-new-blue-50",
      rose: "jm-bg-jutro-new-rose-100 jm-text-jutro-new-rose-900",
      orange: "jm-bg-jutro-new-orange-100 jm-text-jutro-new-orange-900",
      green: "jm-bg-jutro-new-green-100 jm-text-jutro-new-green-800",
      white: "jm-bg-white jm-text-jutro-new-warm-gray-800",
      warmGray: "jm-bg-jutro-new-warm-gray-50"
    },
    full: {
      true: "jm-w-full",
      false: "jm-w-fit"
    }
  },
  defaultVariants: {
    color: "blue",
    full: !0
  }
}), l = ({ text: e, color: t, full: r }) => {
  const o = m({ color: t, full: r });
  return /* @__PURE__ */ j("div", { className: o, dangerouslySetInnerHTML: { __html: e } });
};
export {
  l as MessageBox
};
//# sourceMappingURL=index.js.map
